import { loadNs } from 'common/i18n-config'
import { FORM_MODES } from 'common/models'

const t = loadNs(['components/organisms/assets/asset-form', 'common'])

export const getMemorandumError = (formMode: FORM_MODES, hasTransition: boolean, hasReduction: boolean) => {
  if (formMode === FORM_MODES.EDIT) {
    return t('memorandum_value_error_message_edit')
  }
  if (hasTransition) {
    return t('memorandum_value_error_message_transaction')
  }
  if (hasReduction) {
    return t('memorandum_value_error_message_has_reduction')
  }
  return t('memorandum_value_error_message_new')
}
